import { Hub } from 'aws-amplify';
import React from 'react';
import { AUTH_STATES } from '../../../constants/authConsts';
import { RouteContext } from '../../../context';
import history from '../../../history';
import { OnboardingAuth } from './OnboardingAuth';
import { OnboardingForgotPasswordPage } from './OnboardingForgotPasswordPage';
import { queryParams } from './OnboardingLoginPage';
import { OnboardingRegisterPage } from './OnboardingRegisterPage';

export type OnboardingAuthLayoutProps = {
  onAuthComplete: () => void;
};

export const OnboardingAuthLayout = ({
  onAuthComplete,
}: OnboardingAuthLayoutProps) => {
  const { query }: { query: queryParams } = React.useContext(RouteContext);
  const { step } = query || '';

  // const navigateToLogin = () => {
  //   let loginPath = '/login';
  //   if (query.email) {
  //     loginPath = `${loginPath}?email=${encodeURIComponent(query.email)}`;
  //   }

  //   history.push(loginPath);
  // };

  // const authListenerHandler = data => {
  //   if (
  //     data &&
  //     data.payload &&
  //     data.payload.data &&
  //     data.payload.data.message
  //   ) {
  //     if (data.payload.event === 'signIn_failure') {
  //       // TODO:// Show alert message for sign in failure reason
  //       // if the email and password provided in query are incorrect
  //       // navigate user to login form
  //       navigateToLogin();
  //     }
  //   }
  // };

  // React.useEffect(() => {
  //   // Listen for the auth errors
  //   // Errors come inside `data.payload.data.message`
  //   Hub.listen('auth', authListenerHandler);

  //   return () => {
  //     Hub.remove('auth', authListenerHandler);
  //   };
  // }, []);

  const renderRegisterForm = query.auth && step === AUTH_STATES.SIGN_IN;
  const renderForgotPasswordForm = step === AUTH_STATES.FORGOT_PASSWORD;

  const renderAuthForm = React.useCallback(() => {
    if (query && step) {
      if (renderRegisterForm) {
        return <OnboardingRegisterPage onAuthComplete={onAuthComplete} />;
      }

      if (renderForgotPasswordForm) {
        return <OnboardingForgotPasswordPage onAuthComplete={onAuthComplete} />;
      }
    }

    return <OnboardingAuth onAuthComplete={onAuthComplete} />;
  }, [renderRegisterForm, renderForgotPasswordForm, query]);

  return <>{renderAuthForm()}</>;
};
